module.exports = __webpack_public_path__ + "static/media/26UNRWA19.96c96bb1.jpg";